namespace AgerLMS.LMS {
    export interface DiscountsForm {
        Title: Serenity.StringEditor;
        Coupon: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        DiscountType: Serenity.EnumEditor;
        Source: Serenity.EnumEditor;
        ProductType: Serenity.EnumEditor;
        Users: Serenity.LookupEditor;
        Courses: Serenity.LookupEditor;
        OrderedCourses: Serenity.LookupEditor;
        Categories: Serenity.LookupEditor;
        Percentage: Serenity.IntegerEditor;
        MaxAmount: Serenity.IntegerEditor;
        MinimumOrder: Serenity.IntegerEditor;
        UsableTimes: Serenity.IntegerEditor;
        FixedAmount: Serenity.IntegerEditor;
        OnlyFirst: Serenity.BooleanEditor;
        StartDate: Serenity.DateEditor;
        ExpiryDate: Serenity.DateEditor;
    }

    export class DiscountsForm extends Serenity.PrefixedContext {
        static formKey = 'LMS.Discounts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DiscountsForm.init)  {
                DiscountsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.EnumEditor;
                var w3 = s.LookupEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.DateEditor;

                Q.initFormType(DiscountsForm, [
                    'Title', w0,
                    'Coupon', w0,
                    'Description', w1,
                    'DiscountType', w2,
                    'Source', w2,
                    'ProductType', w2,
                    'Users', w3,
                    'Courses', w3,
                    'OrderedCourses', w3,
                    'Categories', w3,
                    'Percentage', w4,
                    'MaxAmount', w4,
                    'MinimumOrder', w4,
                    'UsableTimes', w4,
                    'FixedAmount', w4,
                    'OnlyFirst', w5,
                    'StartDate', w6,
                    'ExpiryDate', w6
                ]);
            }
        }
    }
}
